import { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { TIMELINE } from "../../data/homeData";

const LegacyTimeline = () => {
  const [active, setActive] = useState(0);
  const total = TIMELINE.length;
  const prev = () => setActive((active - 1 + total) % total);
  const next = () => setActive((active + 1) % total);
  const item = TIMELINE[active];

  return (
    <section
      id="legacy"
      data-testid="legacy-timeline-section"
      className="py-20 bg-[var(--ac-cream)]"
    >
      <div className="ac-container">
        <div className="text-center mb-14">
          <div className="eyebrow">Our Story</div>
          <h2 className="section-heading mt-3" data-testid="legacy-heading">
            Legacy Over <span className="text-[var(--ac-red)]">140 Years Strong</span>
          </h2>
        </div>

        {/* Year pills */}
        <div className="flex items-center justify-center gap-2 md:gap-4 flex-wrap mb-10" data-testid="timeline-years">
          {TIMELINE.map((t, i) => (
            <button
              key={t.year}
              onClick={() => setActive(i)}
              className={`px-5 py-2 rounded-full text-sm font-semibold transition-all ${
                i === active
                  ? "bg-[var(--ac-red)] text-white shadow-[0_8px_22px_-10px_rgba(162,29,35,0.75)]"
                  : "bg-white text-[var(--ac-ink)] border border-[var(--ac-line)] hover:border-[var(--ac-red)] hover:text-[var(--ac-red)]"
              }`}
              data-testid={`timeline-year-${t.year}`}
            >
              {t.year}
            </button>
          ))}
        </div>

        {/* Horizontal rail */}
        <div className="relative mb-12 hidden md:block" data-testid="timeline-rail">
          <div className="h-[2px] bg-[var(--ac-line)] absolute left-0 right-0 top-1/2 -translate-y-1/2" />
          <div
            className="h-[2px] bg-[var(--ac-red)] absolute left-0 top-1/2 -translate-y-1/2 transition-all duration-500"
            style={{ width: `${((active + 1) / total) * 100}%` }}
          />
          <div className="relative grid grid-cols-6 gap-4">
            {TIMELINE.map((t, i) => (
              <div key={t.year} className="flex flex-col items-center">
                <div
                  className={`timeline-dot ${i === active ? "active" : ""}`}
                />
              </div>
            ))}
          </div>
        </div>

        {/* Slide content */}
        <div
          key={active}
          className="grid lg:grid-cols-2 gap-10 items-center ac-fade-up bg-white border border-[var(--ac-line)] rounded-2xl overflow-hidden"
          data-testid="timeline-slide"
        >
          <div className="aspect-[4/3] img-fallback relative">
            <img
              src={item.img}
              alt={item.year}
              className="w-full h-full object-cover"
              loading="lazy"
              onError={(e) => {
                e.currentTarget.style.display = "none";
              }}
              data-testid="timeline-image"
            />
            <div className="absolute bottom-4 left-4 bg-white/95 backdrop-blur px-4 py-2 rounded-md text-[var(--ac-red)] font-bold tracking-wide">
              {item.year}
            </div>
          </div>
          <div className="p-8 lg:p-12">
            <div className="text-6xl md:text-7xl font-bold text-[var(--ac-red)] leading-none mb-5">
              {item.year}
            </div>
            <p className="text-[var(--ac-ink)] text-[17px] leading-relaxed">
              {item.title}
            </p>

            <div className="mt-10 flex items-center gap-3">
              <button
                onClick={prev}
                className="w-11 h-11 rounded-full border border-[var(--ac-line)] flex items-center justify-center hover:border-[var(--ac-red)] hover:text-[var(--ac-red)] transition"
                data-testid="timeline-prev"
                aria-label="Previous"
              >
                <ChevronLeft className="w-5 h-5" />
              </button>
              <button
                onClick={next}
                className="w-11 h-11 rounded-full border border-[var(--ac-line)] flex items-center justify-center hover:border-[var(--ac-red)] hover:text-[var(--ac-red)] transition"
                data-testid="timeline-next"
                aria-label="Next"
              >
                <ChevronRight className="w-5 h-5" />
              </button>
              <div className="ml-auto text-[var(--ac-muted)] text-sm">
                {active + 1} / {total}
              </div>
            </div>
          </div>
        </div>

        <div className="text-center mt-10">
          <a
            href="/why-anderson/140-years"
            className="ds-btn ds-btn--primary"
            data-testid="legacy-explore-btn"
          >
            Our Legacy
          </a>
        </div>
      </div>
    </section>
  );
};

export default LegacyTimeline;
